import Skeleton from "react-loading-skeleton";

export const StandardShipping = ({ shipCost }) => {
  return (
    <div className="shipping-method">
      <div className="shipping-method-info">
        <div>
          <input
            className="form-check-input"
            type="radio"
            name="shippingMethod"
            id="shippingMethod1"
            defaultChecked={false}
            disabled={true}
          />
        </div>
        <label className="form-check-label" htmlFor="shippingMethod1">
          <div className={"d-flex justify-content-between align-items-center"}>
            <div>Standard Shipping</div>
            <div>
              <Skeleton width={50} />{" "}
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};
